export const GET_RESTAURANT = "GET_RESTAURANT";
export const GET_SPECIFIC_RESTAURANT = "GET_SPECIFIC_RESTAURANT";
